export class NotificationModel {
    constructor(
        public body = '',
        public action = ''
    ) { }
}
